export const AiQuotaBadge = ({ q, resetsOn, testid }) => {
  if (!q) return null;
  const out = q.remaining === 0;
  const reset = resetsOn ? resetsOn.split("-").reverse().slice(0, 2).join("/") : "";
  return (
    <div
      className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full border ${out ? "border-rose-500/40 bg-rose-950/40 text-rose-300" : "border-emerald-500/30 bg-emerald-950/30 text-emerald-300"}`}
      data-testid={testid}
      title={`Limite de ${q.limit} por mês. Renova em ${reset}`}
    >
      {out ? `Limite do mês atingido · renova ${reset}` : `${q.remaining} de ${q.limit} restantes no mês`}
    </div>
  );
};
